/**
 * Created by razial on 22.05.2024.
 */

const WarehouseTile = cc.Node.extend({
    ctor: function (ingredient, onSelect, bundle) {
        this._super();

        const styles = cleverapps.styles.WarehouseTile;

        this.selected = false;
        this.ingredient = ingredient;
        this.onSelect = onSelect;

        this.bundle = bundle;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles.size);

        const shadow = this.shadow = cleverapps.UI.createScale9Sprite(bundle.frames.tile_shadow, cleverapps.UI.Scale9Rect.TwoPixelXY);
        shadow.setContentSize(this.width, this.height);
        shadow.setAnchorPoint(0.5, 0);
        shadow.setPosition(this.width / 2, 0);
        this.addChild(shadow);

        const background = this.background = cleverapps.UI.createScale9Sprite(bundle.frames.tile_background);
        background.setContentSize(this.width, this.height);
        background.setAnchorPoint(0.5, 0);
        background.setPosition(this.width / 2, 0);
        this.addChild(background);

        const iconSize = styles.icon.size[cleverapps.resolution.mode];
        const icon = Map2dLocation.currentLocation.harvested.getIngredientIcon(ingredient);
        cleverapps.UI.fitToBox(icon, {
            width: iconSize.width,
            height: iconSize.height,
            maxScale: 1.6
        });
        icon.setAlignment(styles.icon.position);
        background.addChild(icon);

        const titleSize = styles.title.size[cleverapps.resolution.mode];
        const title = cleverapps.UI.generateOnlyText(Map2dLocation.currentLocation.harvested.getIngredientName(ingredient), cleverapps.styles.FONTS.WAREHOUSE_TILE_TITLE_TEXT);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setDimensions(titleSize.width, 0);
        title.fitTo(undefined, titleSize.height);
        title.setAlignment(styles.title.position);
        background.addChild(title);

        const amount = this.amount = cleverapps.UI.generateImageText(Map2dLocation.currentLocation.harvested.get(ingredient), cleverapps.styles.FONTS.WAREHOUSE_TILE_AMOUNT_TEXT);
        amount.fitTo(styles.amount.width);
        amount.setAlignment(styles.amount.position);
        background.addChild(amount);

        const exchangeSize = styles.exchange.size[cleverapps.resolution.mode];
        const exchangeButton = this.exchangeButton = new cleverapps.UI.Button({
            text: Messages.get("WarehouseWindow.exchange"),
            width: exchangeSize.width,
            height: exchangeSize.height,
            onClicked: this.exchange.bind(this)
        });
        exchangeButton.setAlignment(styles.exchange.position);
        exchangeButton.setVisible(false);
        this.addChild(exchangeButton);

        this.clickHandler = cleverapps.UI.onClick(this, this.onClick.bind(this));

        Map2dLocation.currentLocation.harvested.on("onChangeItems", this.onUpdateState.bind(this), this);
    },

    onUpdateState: function () {
        const styles = cleverapps.styles.WarehouseTile;

        const amount = Map2dLocation.currentLocation.harvested.get(this.ingredient);
        const exchangeMinimum = Map2dLocation.currentLocation.harvested.getExchangeMinimum();

        this.amount.setString(amount);
        this.amount.fitTo(styles.amount.width);
        this.amount.setAlignment(styles.amount.position);

        this.exchangeButton.setVisible(this.selected && exchangeMinimum && amount > exchangeMinimum);

        this.clickHandler.setEnabled(!this.selected);
    },

    onClick: function () {
        this.onSelect(this);
    },

    selectTile: function () {
        const styles = cleverapps.styles.WarehouseTile;

        this.selected = true;

        this.onUpdateState();

        this.background.stopAllActions();
        this.background.runAction(new cc.Spawn(
            new cc.ScaleTo(0.1, 1.1),
            new cc.MoveTo(0.1, this.width / 2 + styles.backgroundOffsetX, styles.backgroundOffsetY)
        ));

        this.shadow.stopAllActions();
        this.shadow.runAction(new cc.Spawn(
            new cc.ScaleTo(0.1, 1.1),
            new cc.MoveTo(0.1, this.width / 2 + styles.shadowOffsetX, styles.shadowOffsetY)
        ));
    },

    unselectTile: function () {
        this.selected = false;

        this.onUpdateState();

        this.background.stopAllActions();
        this.background.runAction(new cc.Spawn(
            new cc.ScaleTo(0.1, 1),
            new cc.MoveTo(0.1, this.width / 2, 0)
        ));

        this.shadow.stopAllActions();
        this.shadow.runAction(new cc.Spawn(
            new cc.ScaleTo(0.1, 1),
            new cc.MoveTo(0.1, this.width / 2, 0)
        ));
    },

    exchange: function () {
        if (Map2dLocation.currentLocation.harvested.canTake(this.ingredient, 1)) {
            Map2dLocation.currentLocation.harvested.take(this.ingredient, 1);

            const reward = new Reward("exp", 1);
            reward.receiveReward();
            reward.collectRewardsAnimation(this.amount);
        }
    }
});

cleverapps.styles.WarehouseTile = {
    size: [
        { width: 240, height: 320 },
        { width: 410, height: 540 },
        { width: 410, height: 540 }
    ],

    backgroundOffsetX: 0,
    backgroundOffsetY: 60,

    shadowOffsetX: 14,
    shadowOffsetY: 30,

    title: {
        size: [
            { width: 210, height: 80 },
            { width: 360, height: 80 },
            { width: 360, height: 80 }
        ],
        position: [
            { x: { align: "center" }, y: { align: "center", dy: 110 } },
            { x: { align: "center" }, y: { align: "center", dy: 200 } },
            { x: { align: "center" }, y: { align: "center", dy: 200 } }
        ]
    },

    icon: {
        size: [
            { width: 190, height: 270 },
            { width: 300, height: 400 },
            { width: 300, height: 400 }
        ],
        position: { x: { align: "center" }, y: { align: "center" } }
    },

    amount: {
        width: 200,
        position: [
            { x: { align: "center" }, y: { align: "bottom", dy: 12 } },
            { x: { align: "left", dx: 40 }, y: { align: "bottom", dy: 40 } },
            { x: { align: "left", dx: 40 }, y: { align: "bottom", dy: 40 } }
        ]
    },

    exchange: {
        size: [
            { width: 210, height: 80 },
            { width: 360, height: 110 },
            { width: 360, height: 110 }
        ],
        position: { x: { align: "center", dx: 0 }, y: { align: "bottom", dy: -10 } }
    }
};
